<template>
  <div class="content-container">
    <div v-loading="loading" class="profile__container">
      <ProfileCard>
        <div class="profile__information">
          <h2 class="profile__section-title">Thông tin tài khoản</h2>
          <div class="profile__information-container">
            <InfoList :columns="2" class="profile__info-list">
              <InfoListLabel style="min-width: 150px"
                >ID Nhân viên</InfoListLabel
              >
              <InfoListValue style="min-width: 250px">
                {{ userInfo.code }}
              </InfoListValue>

              <InfoListLabel style="min-width: 150px">Email</InfoListLabel>
              <InfoListValue style="min-width: 250px">
                {{ userInfo.email }}
              </InfoListValue>

              <InfoListLabel>Tên</InfoListLabel>
              <InfoListValue>
                {{ userInfo.full_name }}
              </InfoListValue>

              <InfoListLabel>Bộ phận</InfoListLabel>
              <InfoListValue>
                {{
                  userInfo.department_ids?.map(item => item?.name).join(', ')
                }}
              </InfoListValue>

              <InfoListLabel>Số điện thoại</InfoListLabel>
              <InfoListValue>{{ userInfo.phone_number }}</InfoListValue>

              <InfoListLabel>Nhóm người dùng</InfoListLabel>
              <InfoListValue>
                {{
                  userInfo.user_group_ids?.map(item => item?.name).join(', ')
                }}
              </InfoListValue>
            </InfoList>
          </div>
        </div>

        <div class="profile__section-divider"></div>

        <div class="profile__password-change">
          <h2 class="profile__section-title">Thay đổi mật khẩu</h2>
          <div class="das-form-container">
            <validation-observer ref="passwordFormValidator">
              <div class="das-form-group">
                <div class="das-form-row" style="max-width: 1200px">
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <div class="label">Mật khẩu cũ</div>
                      <div class="password-input-container">
                        <validation-provider
                          :name="$t('field.oldPassword')"
                          rules="required"
                        >
                          <input
                            v-model="passwordData.oldPassword"
                            :type="showPwd ? 'text' : 'password'"
                          />
                        </validation-provider>
                        <div
                          class="eye-password"
                          :class="[showPwd ? 'show' : 'hide']"
                          @click="showPwd = !showPwd"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <div class="label">Mật khẩu mới</div>
                      <div class="password-input-container">
                        <validation-provider
                          :name="$t('field.newPassword')"
                          rules="required|password|max:255|min:8"
                          vid="newPassword"
                        >
                          <input
                            v-model="passwordData.newPassword"
                            :type="showPwd ? 'text' : 'password'"
                          />
                        </validation-provider>
                        <div
                          class="eye-password"
                          :class="[showPwd ? 'show' : 'hide']"
                          @click="showPwd = !showPwd"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <div class="label">Xác nhận mật khẩu</div>
                      <div class="password-input-container">
                        <validation-provider
                          :name="$t('field.passwordConfirm')"
                          rules="required|password|confirmed:newPassword|max:255|min:8"
                        >
                          <input
                            v-model="passwordData.passwordConfirm"
                            :type="showPwdConfirm ? 'text' : 'password'"
                          />
                        </validation-provider>
                        <div
                          class="eye-password"
                          :class="[showPwdConfirm ? 'show' : 'hide']"
                          @click="showPwdConfirm = !showPwdConfirm"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </validation-observer>
          </div>
        </div>

        <div>
          <button class="btn primary small" @click="fnSubmitChangePwdForm">
            Cập nhật
          </button>
        </div>
      </ProfileCard>
    </div>
    <!-- <div class="profile__password-change">
        <ProfileCard>
          <h2 class="profile__section-title">Thay đổi mật khẩu</h2>
        </ProfileCard>
      </div> -->
  </div>
</template>

<script>
import ProfileCard from './components/ProfileCard.vue'

// eslint-disable-next-line no-unused-vars
import { getUserDetailApi, userUpdatePasswordApi } from '@/api/profile/profile'
import { changePasswordApi } from '@/api/auth_service/login'
import { notifyError } from '@/utils/toast'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ProfileCard
  },
  data() {
    return {
      loading: false,
      userInfo: {
        id: null,
        email: null,
        code: null,
        phone_number: null,
        department_ids: [],
        user_group_ids: [],
        id_card: null,
        full_name: null
      },

      passwordData: {
        oldPassword: null,
        newPassword: null,
        passwordConfirm: null
      },
      showPwd: false,
      showPwdConfirm: false
    }
  },
  mounted() {
    this.getAccountDetail()
  },
  methods: {
    getAccountDetail() {
      this.loading = true
      getUserDetailApi()
        .then(res => {
          this.userInfo = res.data.user
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fnSubmitChangePwdForm() {
      if (
        (await this.$vxForm.isValid(this.$refs.passwordFormValidator)) === false
      ) {
        return
      }
      const payload = {
        username: this.userInfo.username,
        password: this.passwordData.oldPassword,
        new_password: this.passwordData.newPassword
      }

      await changePasswordApi(payload)
        .then(res => {
          this.$message({
            message: 'Đổi mật khẩu thành công',
            type: 'success'
          })
          this.passwordData = {
            oldPassword: null,
            newPassword: null,
            passwordConfirm: null
          }
        })
        .catch(error => {
          notifyError(error.response?.data?.message)
        })
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.content-container {
  background-color: $appBG;
}

.profile__container {
  display: grid;
  // grid-template-columns: 1.5fr 1fr;
  gap: 20px;
  .profile__information,
  .profile__password-change {
    margin: 20px 0;
  }

  .profile__information {
    .profile__information-container {
    }

    .profile__info-list {
      max-width: 800px;
      column-gap: 5px;
      row-gap: 20px;
      border: none;
      padding: 0;
    }
  }

  .profile__password-change {
  }

  .profile__section-title {
    font-size: 20px;
    font-weight: 600;
    margin: 20px 0;
  }

  .profile__section-divider {
    width: 100%;
    border: 1px solid #e5e5e5;
    height: 1px;
    margin: 20px 0;
  }

  .profile__actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
  }

  .password-input-container {
    position: relative;

    input {
      padding-right: 36px;
    }

    .eye-password {
      position: absolute;
      top: 50%;
      transform: translateY(calc(-50% + 2px));
      right: 10px;
      width: 20px;
      height: 20px;
      cursor: pointer;

      &.hide {
        // background: url('/src/styles/images/mci_eye_slash_icon.svg') no-repeat;
        background: url('../../../styles/images/svg/mci_eye_slash_icon.svg')
          no-repeat;
      }

      &.show {
        background: url('../../../styles/images/svg/mci_eye_icon.svg') no-repeat;
      }
    }
  }
}
</style>
